import api from './api';

export const getGenres = () => api.get('/api/v1/genres');
export const getGenre = (id) => api.get(`/api/v1/genres/${id}`);
export const createGenre = (payload) => api.post('/api/v1/genres', payload);
export const updateGenre = (id, payload) => api.put(`/api/v1/genres/${id}`, payload);
export const deleteGenre = (id) => api.delete(`/api/v1/genres/${id}`);
